import { Optional, ScopeEnum } from "config";

export const checkPermissions = (
  userPermissions: Optional<string[]>,
  allowedPermissions: ScopeEnum | ScopeEnum[],
  includeAllPermissions?: boolean
): boolean => {
  if (Array.isArray(allowedPermissions)) {
    if (includeAllPermissions) {
      return allowedPermissions.every((p) =>
        Boolean(userPermissions?.includes(p))
      );
    } else {
      return allowedPermissions.some((p) =>
        Boolean(userPermissions?.includes(p))
      );
    }
  }

  return Boolean(userPermissions?.includes(allowedPermissions));
};
